var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"qwContacts"},_vm._l((_vm.datas),function(item,index){return _c('div',{key:index},[_c('ww-open-data',{attrs:{"type":_vm.type,"openid":item[_vm.openid]},on:{"click":_vm.setOpenData}})],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }